export default "__VITE_ASSET__CrrR$t$7__"